export enum WelcomeOffer {
  WO_REGISTRATION_SELECTION = 'WelcomeOfferRegistrationSelectionEvent',
  WO_CLAIM_SUCCESS = 'WelcomeOfferClaimEventSuccess',
  WO_CLAIM_FAILURE = 'WelcomeOfferClaimEventFailure',
  WO_CTA_MORE_INFO_CLICK = 'WelcomeOfferCtaMoreInfoClick',
}
